import { useEffect, useRef } from "react";

type CallbackFunction = () => Promise<void>;
type CommonFunction = () => void;

export enum TimeLimitCacheQITechEnum {
	START = "@FGTS:TIME_LIMIT_PROPOSAL",
}
// intervalo de verificação de 1 segundo
const intervalVerification = 1000;
// limite de tempo de 15 minutos
const timeLimit = 15 * 60 * 1000;

// interface de retorno do hook
export interface MonitorTimeLimitProposal {
	startTimeoutBalance(dateTimer: number): void;
	resetSimulationAndStep(fn: CallbackFunction | CommonFunction): void;
}

export const useMonitorTimeLimitProposal = (): MonitorTimeLimitProposal => {
	const savedCallback = useRef<CallbackFunction | CommonFunction | null>(null);

	// inicia o timer registrando na sessionStorage
	const startTimeoutBalance = (dateTimer: number): void => {
		sessionStorage.setItem(TimeLimitCacheQITechEnum.START, String(dateTimer));
	};

	// executa o callback para resetar a simulação
	const resetSimulationAndStep = (fn: CallbackFunction | CommonFunction): void => {
		savedCallback.current = fn;
	};

	// verifica periodicamente se o timer atingiu 15 minutos e executa o savedCallback
	useEffect(() => {
		const tick = (): void => {
			const currentTime = new Date().getTime();
			const timeLimitProposal = sessionStorage.getItem(TimeLimitCacheQITechEnum.START);

			if (timeLimitProposal) {
				const timeLimitProposalNumber = parseInt(timeLimitProposal);

				if (currentTime - timeLimitProposalNumber >= timeLimit && savedCallback.current) {
					savedCallback.current();
					sessionStorage.removeItem(TimeLimitCacheQITechEnum.START);
				}
			}
		};

		const id = setInterval(tick, intervalVerification);

		return () => {
			clearInterval(id);
		};
	}, [intervalVerification]);

	return { startTimeoutBalance, resetSimulationAndStep };
};
